import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { PUBLIC_ACCOUNT_STATUSES } from "models";
import { AccessKeysDashboardQueryKeys } from "modules/AccessKeysDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useRevokeAccountMutation = () =>
  useTypedMutation<number, void>({
    mutationFn: async id => {
      await ApiInstance.post("/publicapi/account/revoke", { id }, ENV.dealerBaseURL);
    },
    onSuccess: revokedId => {
      const accounts = typedQueryClient.getQueryData(AccessKeysDashboardQueryKeys.accounts);
      if (!accounts) return;

      const accountIdx = accounts.findIndex(account => account.id === revokedId);
      if (accountIdx === -1) return;

      typedQueryClient.setQueryData(
        AccessKeysDashboardQueryKeys.accounts,
        accounts.with(accountIdx, { ...accounts[accountIdx], status: PUBLIC_ACCOUNT_STATUSES.PublicAccountRevoked })
      );
    }
  });
